const React = require('react');
const {SortDirectionStore} = require('../stores/QueryStores');
const {CmdUpdateControlLabelStore,CmdUpdateControlPropertyStore} = require('../stores/CmdTypeStore');
import QueryActions from '../actions/QueryActions';
import ControlPropertyConst from '../formItem/ControlPropertyConst';


const SortableHeaderCell = React.createClass({
  	propTypes: {
	    column: React.PropTypes.shape({ name: React.PropTypes.node })
	},

	getInitialState(): {sortDirection: string} {
	    return {
        sortDirection: '',
        notNull:this.props.column.notNull,
        label:this.props.column.name
      };
	  },

	componentDidMount:function componentDidMount() {
		this.unsubscribeUpdateSortDirection = SortDirectionStore.listen(this.onUpdateSortDirection);
	  this.unsubscribeCmdUpdateControlLabelStore = CmdUpdateControlLabelStore.listen(this.onCmdUpdateControlLabel);
    this.unsubscribeCmdUpdateControlPropertyStore = CmdUpdateControlPropertyStore.listen(this.onCmdUpdateControlProperty);
  },

  onCmdUpdateControlLabel:function(name,_label)
  {
    if(this.props.column.xmlName == name)
    {
      this.setState({label:_label});
    }
  },

  onCmdUpdateControlProperty:function(name,property,value)
  {
    if(this.props.column.xmlName == name)
    {
      if(property == ControlPropertyConst.NOTNULL)
      {
        this.setState({notNull:value});
      }
    }
  },

 
  getSortByText: function() {

	    let unicodeKeys = {
	      ASC: 9650,
	      DESC: 9660
    	};
      var _sortDirection=this.state.sortDirection;
      var ret;
      if(_sortDirection==undefined||_sortDirection==''){
          ret='';
      }else{
        ret=String.fromCharCode(unicodeKeys[_sortDirection]);
      }
      // var ret= _sortDirection==undefined?'':(String.fromCharCode(unicodeKeys[_sortDirection]));
	    // console.log('ret:'+ret);
      return ret=String.fromCharCode(9650);

  },
  setSortStyle:function(upSty,downSty){
    var _sortDirection=this.state.sortDirection;
    if(_sortDirection=="ASC"){
      upSty.borderBottomColor='#5473e8';
    }else if(_sortDirection=="DESC"){
      downSty.borderTopColor='#5473e8';
    }
  },

  onUpdateSortDirection:function(groupAlias,arg)
  {
  	var _sortDirection;
    if(this.props.groupAlias == groupAlias)
    {
    	var _columnKey=this.props.column.key.toLowerCase();
      	if(arg.hasOwnProperty(_columnKey)){
      		_sortDirection=arg[_columnKey];
      	}
        if(_sortDirection==undefined){

        }
      this.setState({sortDirection:_sortDirection})

    }
  },

  onClick:function(e) {
    e.stopPropagation();
    e.preventDefault();
    var columnKey=this.props.column.key;
    var sortDirection=this.state.sortDirection;
    var _sortDirection;
    if(sortDirection=='ASC')
    {
      _sortDirection='DESC'
      $(this.dataGridSortUpNode).css('borderBottomColor','#c0c4cc')
      $(this.dataGridSortDownNode).css('borderTopColor','#5473e8')
    }else if(sortDirection=='DESC'){
      _sortDirection=undefined;
      $(this.dataGridSortUpNode).css('borderBottomColor','#c0c4cc')
      $(this.dataGridSortDownNode).css('borderTopColor','#c0c4cc')
    }else{
      _sortDirection='ASC';
      $(this.dataGridSortUpNode).css('borderBottomColor','#5473e8')
      $(this.dataGridSortDownNode).css('borderTopColor','#c0c4cc')
    }
    QueryActions.gridHeaderClickSort(columnKey,_sortDirection,this.props.moduleInstanceId);
    
  },

  sortDownClick(e){
    e.stopPropagation();
    e.preventDefault();
    var columnKey=this.props.column.key;
    var sortDirection=this.state.sortDirection;
    var _sortDirection;
    if(sortDirection=='DESC')
    {
      _sortDirection=undefined;
      $(this.dataGridSortUpNode).css('borderBottomColor','#c0c4cc')
      $(this.dataGridSortDownNode).css('borderTopColor','#c0c4cc')
    }else{
      _sortDirection='DESC';
      $(this.dataGridSortUpNode).css('borderBottomColor','#c0c4cc')
      $(this.dataGridSortDownNode).css('borderTopColor','#5473e8')
    }
    QueryActions.gridHeaderClickSort(columnKey,_sortDirection,this.props.moduleInstanceId);
  },
  sortUpClick(e){
    e.stopPropagation();
    e.preventDefault();
    var columnKey=this.props.column.key;
    var sortDirection=this.state.sortDirection;
    var _sortDirection;
    if(sortDirection=='ASC')
    {
      _sortDirection=undefined;
      $(this.dataGridSortUpNode).css('borderBottomColor','#c0c4cc')
      $(this.dataGridSortDownNode).css('borderTopColor','#c0c4cc')
    }else{
      _sortDirection='ASC';
      $(this.dataGridSortUpNode).css('borderBottomColor','#5473e8')
      $(this.dataGridSortDownNode).css('borderTopColor','#c0c4cc')
    }
    QueryActions.gridHeaderClickSort(columnKey,_sortDirection,this.props.moduleInstanceId);
  },

  getIconStyle:function(){

    var iconStyle={};
    iconStyle['fontSize']='8px';
    iconStyle['color']='red';
    var notNull=this.state.notNull;
    if(!notNull){
      iconStyle['display']='none';
    }
    return iconStyle;
  },
  HeadMouseMove:function(){
    if($(this.sortModel).hasClass('absoluteSort')){
      $(this.sortModel).css('display','block');
    }
  },
  HeadSortMouseLeave:function(){ 
    if($(this.sortModel).hasClass('absoluteSort')){
      $(this.sortModel).css('display','none');
    }
  },

  render: function(): ?ReactElement {
    let xmlName = "";
    if(this.props.column)
        xmlName = this.props.column.key;
    let _justifyContent="end"
    if(this.props.textAlign=='left'){
      _justifyContent='start'
    }
    if(this.props.textAlign=='center'){
      _justifyContent='center'
    }
    let dataGridSortUpStyle={ width: 0,height: 0,border: 'solid 5px transparent',position: 'relative',right: '-5px',borderBottomColor: '#c0c4cc',bottom: '13px'};
    let dataGridSortDownStle={ width: 0,height: 0,border: 'solid 5px transparent',position: 'relative',right: '5px',borderTopColor: '#c0c4cc',top: '13px'};
    this.setSortStyle(dataGridSortUpStyle,dataGridSortDownStle);
    let _sortSpanStyle = {width:'20px',height:'17px'};
    let _sortClass='';
    if((this.state.label.visualLength()+20)>this.props.column.width){
      _sortSpanStyle = {display:'none',width:'20px',height:'17px',position:'absolute',top:'3px',backgroundColor: 'rgb(255,255,255,0.6)',right:'3px',borderRadius:'18px'};
      _sortClass ="absoluteSort"
    }
    return (
      <div data-xmlName={xmlName} alt="" style={{display:'flex',mmcursor: 'pointer',textAlign:this.props.textAlign,justifyContent:_justifyContent}} onClick={this.onClick} onMouseEnter={this.HeadMouseMove} onMouseLeave={this.HeadSortMouseLeave}>
          <i className='fa fa-snowflake-o' style={this.getIconStyle()}></i>
          {this.state.label}
        <span style={_sortSpanStyle} className={_sortClass} ref={node=>this.sortModel=node}>
          {/* <span style={{opacity:0}}>{this.getSortByText()}</span> */}
          <i ref={node=>this.dataGridSortUpNode=node} className='dataGridSortUp' style={dataGridSortUpStyle} onClick={this.sortUpClick}></i>
          <i ref={node=>this.dataGridSortDownNode=node} className='dataGridSortDown' style={dataGridSortDownStle} onClick={this.sortDownClick}></i>
        </span>
      </div>
    );
  }
});

module.exports = SortableHeaderCell;



// WEBPACK FOOTER //
// ./src/export/GongqiHeaderCell.js